module.exports = __webpack_public_path__ + "img/github_logo.438c93c0.png";